var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchCaret = function SvgSearchCaret(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.913 4.483 6.191 8.362a.303.303 0 0 1-.417 0L2.087 4.483C1.9 4.305 2.033 4 2.295 4h7.41c.262 0 .394.305.208.483Z",
    fill: "currentColor"
  })));
};
export default SvgSearchCaret;